(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
class LocalizationForm extends HTMLElement {
constructor() {
super();
this.elements = {
input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
button: this.querySelector('button'),
panel: this.querySelector('.disclosure__list-wrapper'),
};
this.elements.button.addEventListener('click', this.openSelector.bind(this));
this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
}

hidePanel() {
this.elements.button.setAttribute('aria-expanded', 'false');
this.elements.panel.setAttribute('hidden', true);
}

onContainerKeyUp(event) {
if (event.code.toUpperCase() !== 'ESCAPE') return;

this.hidePanel();
this.elements.button.focus();
}

onItemClick(event) {
event.preventDefault();
const form = this.querySelector('form');
this.elements.input.value = event.currentTarget.dataset.value;
if (form) form.submit();
}

openSelector() {
this.elements.button.focus();
this.elements.panel.toggleAttribute('hidden');
this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') ===
'false').toString());
}

closeSelector(event) {
const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
if (event.relatedTarget === null || shouldClose) {
this.hidePanel();
}
}
}

customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-emd-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-lp-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

     if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
   
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-sas-tv-kit-section"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    var product_id = $('.sas-page-kit.selected.active').attr("data-sas_product_kit");
    $("#free-gift-"+product_id).show();

    let productName = $('.sas-page-kit:first').find('.sas-kit-title').html();
    let productPrice = $('.sas-page-kit:first').find('#sas-kit-price').html();
    let btnProductName = $('#checkout-button-product-name');
    let btnProductPrice = $('#checkout-button-product-price');
    btnProductName.html(productName);
    btnProductPrice.html(productPrice);
    
    $(".sas-page-kits-wrapper .sas-page-kit").click(function(e) {
        
      $('.sas-page-kit').removeClass('active selected');
      $(this).siblings().find('.one-time').removeClass('active');
      $(this).addClass("active selected");
      $(this).addClass("active selected");
      create_sticky_footer($(this).find(".sas-kit-image > img"),$(this).find(".sas-kit-title"),$(this).find(".sas-kit-price"),$(this).find(".sas-kit-cta"),$(this).attr("id"));
      setTimeout(function(){
        if($('.sas-page-kit.selected.active .subscription.active').length == 0 && $('.sas-page-kit.selected.active .one-time.active').length == 0){
          $('.sas-page-kit.selected.active .subscription .purchase-option-kit').trigger('click');
          var product_id = $('.sas-page-kit.selected.active').attr("data-sas_product_kit");
          $(".show-specific-sas-only").hide();
          $("#free-gift-"+product_id).show();
      
          // Check Out footer update
          productName = $('.sas-page-kit.selected.active').find('.sas-kit-title').html();
          productPrice = $('.sas-page-kit.selected.active').find('#sas-kit-price').html();
          btnProductName.html(productName);
          btnProductPrice.html(productPrice);
        }
      },200);
    });
      
    // $(".sas-page-kits-wrapper .sas-page-kit .sas-kit-event").click(function(e){
    //   $('.sas-page-kit').removeClass('active selected');
    //     $(this).parent('.sas-page-kit').addClass("active selected");
    //     create_sticky_footer($(this).find(".sas-kit-image > img"),$(this).find(".sas-kit-title"),$(this).find(".sas-kit-price"),$(this).find(".sas-kit-cta"))
    //     $('.sas-page-kit').not($(this).parent('.sas-page-kit')).removeClass('active selected');
    //     $(this).find('.radio-button-container').trigger('click');
    // });
      
    $('.sas-page-kit.active.selected').trigger("click");
    $(".sas-page-kits-wrapper .sas-page-kit .sas-kit-event .whatsincluded::after").click(function(e) {
      $('.sas-page-kit.active.selected').trigger("click");
    });

    if( screen.width <= 480 ) { 
      $('.accordion-include-section .include-accordion').removeClass( "show" ); 
    }
  });

  function create_sticky_footer(image_src_element,title_element,price_element,button_element,this_id){
    // console.log("The ID of the clicked button is: " + this_id);
    //   $('#'+this_id+" input[type='radio']:first").prop("checked", true);
    //  console.log($('#'+this_id+" input[type='radio']").length);
    $(".prod-img > img").attr("src", image_src_element.attr("src"));
    $(".prod-name > .prod-title").html(title_element.text());
    $(".footer-cart-actions").html(button_element.clone().addClass("sas-kit-footer-cta").attr("href", "javascript:void()"));
    $(".sticky-footer-price").html(price_element.html());
  }

  /*
  $(".sas-purchase-option .one-time").click(function(e){
    console.log('trigger-2-'+$(this).attr("id"));
    $('#'+$(this).attr("id")+" input[type='radio']").prop("checked", true);
  });
  */

  $(document).ready(function() {
    var ticking = false;
    
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          var scrollTop = $(window).scrollTop();
          var $stickyFooter = $(".sticky-sas");
          if (scrollTop > 2450 && !$('.sas-kit-event .sas-kit-cta').isInViewport()) {
            create_sticky_footer(
              $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-image > img"),
              $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-title"),
              $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-price"),
              $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-cta")
            );
            $stickyFooter.show();
          } else {
            $stickyFooter.hide();
          }
          ticking = false;
        });
        ticking = true;
      }
    }
    
    $(window).on('load resize scroll', onScroll);

    $.getJSON('/cart.js', function (cart) {
      var productIds = cart.items.map(function (item) {
        return String(item.product_id);
      });
      var variantIds = cart.items.map(function (item) {
        return String(item.variant_id);
      });

      $('.sas-page-kit').each(function () {
        var kitId = $(this).data('sas_product_kit').toString();

        if (productIds.includes(kitId) || variantIds.includes(kitId)) {
          // $('.sas-page-kit').removeClass('active selected');
          // $(this).addClass('active selected');
          
          let btnProductName = $('#checkout-button-product-name');
          let btnProductPrice = $('#checkout-button-product-price');

          let productName = $('.sas-page-kit.selected.active').find('.sas-kit-title').html();
          let productPrice = $('.sas-page-kit.selected.active').find('#sas-kit-price').html();

          btnProductName.html(productName);
          btnProductPrice.html(productPrice);
        }
      });
    });

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-tv-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-lp-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

     if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
   
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-upsell-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      // this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.header) {
        return;
      }
      
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

     // if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
   
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sas-header-with-cart"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sas-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      // this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.header) {
        return;
      }
      
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

     // if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
   
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sas-kit-section"] && !Shopify.designMode) return;
  try {
    
   $(document).ready(function() {

      $(".sas-page-kits-wrapper .sas-page-kit .sas-kit-event").click(function(e){
        $('.sas-page-kit').removeClass('active selected');
        $(this).parent('.sas-page-kit').siblings().find('.one-time').removeClass('active');
        $(this).parent('.sas-page-kit').addClass("active selected");
        create_sticky_footer($(this).find(".sas-kit-image > img"),$(this).find(".sas-kit-title"),$(this).find(".sas-kit-price"),$(this).find(".sas-kit-cta"),$(this).attr("id"));
        setTimeout(function(){
          if($('.sas-page-kit.selected.active .subscription.active').length == 0 && $('.sas-page-kit.selected.active .one-time.active').length == 0){
            $('.sas-page-kit.selected.active .subscription .purchase-option-kit').trigger('click');
          }
        },200);
      });
          // $(".sas-page-kits-wrapper .sas-page-kit .sas-kit-event").click(function(e){
          //   $('.sas-page-kit').removeClass('active selected');
          //     $(this).parent('.sas-page-kit').addClass("active selected");
          //     create_sticky_footer($(this).find(".sas-kit-image > img"),$(this).find(".sas-kit-title"),$(this).find(".sas-kit-price"),$(this).find(".sas-kit-cta"))
          //     $('.sas-page-kit').not($(this).parent('.sas-page-kit')).removeClass('active selected');
          //     $(this).find('.radio-button-container').trigger('click');
          // });
          $('.sas-page-kit.active.selected').trigger("click");
          $(".sas-page-kits-wrapper .sas-page-kit .sas-kit-event .whatsincluded::after").click(function(e){
            $('.sas-page-kit.active.selected').trigger("click");
          });

          if( screen.width <= 480 ) { $('.accordion-include-section .include-accordion').removeClass( "show" ); }

    });


      function create_sticky_footer(image_src_element,title_element,price_element,button_element,this_id){

     // console.log("The ID of the clicked button is: " + this_id);

        //   $('#'+this_id+" input[type='radio']:first").prop("checked", true);
      //  console.log($('#'+this_id+" input[type='radio']").length);

        $(".prod-img > img").attr("src", image_src_element.attr("src"));
        $(".prod-name > .prod-title").html(title_element.text());
        $(".footer-cart-actions").html(button_element.clone().addClass("sas-kit-footer-cta").attr("href", "javascript:void()"));
        $(".sticky-footer-price").html(price_element.html());
      }

     /*$(".sas-purchase-option .one-time").click(function(e){
       console.log('trigger-2-'+$(this).attr("id"));
         $('#'+$(this).attr("id")+" input[type='radio']").prop("checked", true);
   });*/

  $(document).ready(function() {
    $(window).on('load resize scroll', function() {
          var scrollTop = $(this).scrollTop();
          var $stickyFooter = $(".sticky-sas");
          if (!$('.sas-kit-event .sas-kit-cta').isInViewport()) {
            create_sticky_footer($(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-image > img"),$(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-title"),$(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-price"),$(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-cta"))
             $stickyFooter.show();
          } else {
            $stickyFooter.hide();
          }
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sas-tv-kit-section"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    var product_id = $('.sas-page-kit.selected.active').attr("data-sas_product_kit");
    $("#free-gift-"+product_id).show();

    let productName = $('.sas-page-kit:first').find('.sas-kit-title').html();
    let productPrice = $('.sas-page-kit:first').find('#sas-kit-price').html();
    let btnProductName = $('#checkout-button-product-name');
    let btnProductPrice = $('#checkout-button-product-price');
    btnProductName.html(productName);
    btnProductPrice.html(productPrice);

    if ($('.sas-page-kits-section').length > 0) {
      document.addEventListener("click", function (e) {
        const trigger = e.target.closest(".sas-kit-cta");
        if (!trigger) return;

        e.preventDefault();
        if (trigger) {
          $('#click-preloader').addClass('active');
        }
      });
    }
    
    $(".sas-page-kits-wrapper .sas-page-kit").click(function(e) {
      $('.sas-page-kit').removeClass('active selected');
      $(this).siblings().find('.one-time').removeClass('active');
      $(this).addClass("active selected");
      $(this).addClass("active selected");
      create_sticky_footer($(this).find(".sas-kit-image > img"),$(this).find(".sas-kit-title"),$(this).find(".sas-kit-price"),$(this).find(".sas-kit-cta"),$(this).attr("id"));
      setTimeout(function(){
        if($('.sas-page-kit.selected.active .subscription.active').length == 0 && $('.sas-page-kit.selected.active .one-time.active').length == 0){
          $('.sas-page-kit.selected.active .subscription .purchase-option-kit').trigger('click');
          var product_id = $('.sas-page-kit.selected.active').attr("data-sas_product_kit");
          $(".show-specific-sas-only").hide();
          $("#free-gift-"+product_id).show();
      
          // Check Out footer update
          productName = $('.sas-page-kit.selected.active').find('.sas-kit-title').html();
          productPrice = $('.sas-page-kit.selected.active').find('#sas-kit-price').html();
          btnProductName.html(productName);
          btnProductPrice.html(productPrice);
        }
      },200);
    });
      
    // $(".sas-page-kits-wrapper .sas-page-kit .sas-kit-event").click(function(e){
    //   $('.sas-page-kit').removeClass('active selected');
    //     $(this).parent('.sas-page-kit').addClass("active selected");
    //     create_sticky_footer($(this).find(".sas-kit-image > img"),$(this).find(".sas-kit-title"),$(this).find(".sas-kit-price"),$(this).find(".sas-kit-cta"))
    //     $('.sas-page-kit').not($(this).parent('.sas-page-kit')).removeClass('active selected');
    //     $(this).find('.radio-button-container').trigger('click');
    // });
      
    $('.sas-page-kit.active.selected').trigger("click");
    $(".sas-page-kits-wrapper .sas-page-kit .sas-kit-event .whatsincluded::after").click(function(e) {
      $('.sas-page-kit.active.selected').trigger("click");
    });

    if( screen.width <= 480 ) { 
      $('.accordion-include-section .include-accordion').removeClass( "show" ); 
    }
  });

  function create_sticky_footer(image_src_element,title_element,price_element,button_element,this_id){
    // console.log("The ID of the clicked button is: " + this_id);
    //   $('#'+this_id+" input[type='radio']:first").prop("checked", true);
    //  console.log($('#'+this_id+" input[type='radio']").length);
    $(".prod-img > img").attr("src", image_src_element.attr("src"));
    $(".prod-name > .prod-title").html(title_element.text());
    $(".footer-cart-actions").html(button_element.clone().addClass("sas-kit-footer-cta").attr("href", "javascript:void()"));
    $(".sticky-footer-price").html(price_element.html());
  }

  /*
  $(".sas-purchase-option .one-time").click(function(e){
    console.log('trigger-2-'+$(this).attr("id"));
    $('#'+$(this).attr("id")+" input[type='radio']").prop("checked", true);
  });
  */

  $(document).ready(function() {
    var ticking = false;
    
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          var scrollTop = $(window).scrollTop();
          var $stickyFooter = $(".sticky-sas");
          if (scrollTop > 2450 && !$('.sas-kit-event .sas-kit-cta').isInViewport()) {
            create_sticky_footer(
              $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-image > img"),
              $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-title"),
              $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-price"),
              $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-cta")
            );
            $stickyFooter.show();
          } else {
            $stickyFooter.hide();
          }
          ticking = false;
        });
        ticking = true;
      }
    }
    
    $(window).on('load resize scroll', onScroll);

    $.getJSON('/cart.js', function (cart) {
      var productIds = cart.items.map(function (item) {
        return String(item.product_id);
      });
      var variantIds = cart.items.map(function (item) {
        return String(item.variant_id);
      });

      $('.sas-page-kit').each(function () {
        var kitId = $(this).data('sas_product_kit').toString();

        if (productIds.includes(kitId) || variantIds.includes(kitId)) {
          // $('.sas-page-kit').removeClass('active selected');
          // $(this).addClass('active selected');
          
          let btnProductName = $('#checkout-button-product-name');
          let btnProductPrice = $('#checkout-button-product-price');

          let productName = $('.sas-page-kit.selected.active').find('.sas-kit-title').html();
          let productPrice = $('.sas-page-kit.selected.active').find('#sas-kit-price').html();

          btnProductName.html(productName);
          btnProductPrice.html(productPrice);
        }
      });
    });

  });


  } catch(e) { console.error(e); }
})();
})();
